import React from "react"

import { Row, Col } from 'antd'

import LogoButton from "./LogoButton"

const linkAbout = 'https://fitgames.tw/helper/#about'

export default function Navigation() {
    return (
        <div>
            <Row type="flex" align="middle" justify="space-between">
                <Col className="nav-logo">
                    <LogoButton transparent={true} />
                </Col>

                <Col>
                    <Row type="flex" align="middle" justify="end">
                        <a href="/list" className="nav-title">賽事專區</a>
                        <a href={linkAbout} className="nav-title">關於FitGames</a>
                    </Row>
                </Col>

            </Row>

        </div>

    )
}
